<template>
    <div>
        <form v-if="cfg && cfg.formUrl" method="post" target="_tmpl_test" :action="cfg.formUrl" enctype="multipart/form-data">
            <input type="file" name="file" />
            <button type="submit">提交</button>
        </form>
    </div>
</template>
<script>
export default {
    name: "dialog-file-input",
    props: {
        cfg: Object,
    },
    data() {
        return {
        };
    },
};
</script>